import './Demands.scss'

import { Collapse, Spin } from 'antd'
import CenteredLayout from 'components/centered-layout/CenteredLayout'
import React, {useContext} from 'react'

import AppContext from "../../context/AppContext";
import { useUyeBildirimMailleriQuery } from '../../gql/GeneratedGraphqlTypes'

const { Panel } = Collapse

const Demands = () => {

  const { email } = useContext(AppContext)
  // Burada 1 yerine giriş yapmış kullanıcının ID'sini kullanabilirsin
  const { data, loading, error } = useUyeBildirimMailleriQuery({
    variables: { email:email},
    fetchPolicy: 'no-cache',
  })

  const demands = data?.uyeBildirimMailleri ?? []

  return (
      <CenteredLayout maxWidth={1250}>
        <div className="demands-container">
          <h2>Taleplerim</h2>

          {loading ? (
              <div className="loading-center">
                <Spin tip="Yükleniyor..." />
              </div>
          ) : error ? (
              <p style={{ color: 'red' }}>Veri alınırken bir hata oluştu: {error.message}</p>
          ) : (
              <div className="demands-list">
                {demands.length === 0 ? (
                    <div className="no-demands">
                      <p>Henüz bir talebiniz yok.</p>
                    </div>
                ) : (
                    demands.map((demand, index) => (
                        <Collapse
                            bordered={false}
                            className="demand"
                            key={index}
                            defaultActiveKey={[index.toString()]} // her panelin varsayılan olarak açık gelmesini sağlar
                        >
                            <Panel
                                header={<p className="demand-title">{demand.tarih}</p>}
                                key={index.toString()}
                            >
                                <div className="response">
                                    <p>{demand.aciklama}</p>
                                </div>
                            </Panel>
                        </Collapse>
                    ))
                )}
              </div>
          )}
        </div>
      </CenteredLayout>
  )
}

export default Demands
